var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "table-content row-data" },
    [
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loadingData,
              expression: "loadingData",
            },
          ],
          attrs: {
            "element-loading-spinner": "el-icon-loading",
            "empty-text": _vm.textTable,
            data: _vm.responseFilterList,
            "element-loading-text": _vm.$tableLoading,
            "element-loading-background": "rgba(255,255,255, 0)",
            "header-cell-style": _vm.tableHeaderColor,
            "max-height": _vm.$tableMaxHeight,
            border: "",
            "summary-method": _vm.getSummaries,
            "show-summary": "",
          },
          on: { "selection-change": _vm.handleSelectionChange },
        },
        [
          _c("el-table-column", {
            attrs: { type: "selection", align: "center", width: "55" },
          }),
          _c("el-table-column", {
            attrs: {
              type: "index",
              fixed: "left",
              label: "STT",
              width: "50",
              align: "center",
            },
          }),
          _c("el-table-column", {
            attrs: { width: "150", fixed: "left", label: "Họ tên" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("el-tooltip", { attrs: { placement: "top" } }, [
                      _c(
                        "div",
                        { attrs: { slot: "content" }, slot: "content" },
                        [
                          _vm._v("Mã học sinh: " + _vm._s(scope.row.kidCode)),
                          _c("br"),
                          _vm._v(
                            "Bố/Mẹ: " +
                              _vm._s(scope.row.fatherPhone) +
                              " -\n            " +
                              _vm._s(scope.row.motherPhone) +
                              "\n          "
                          ),
                        ]
                      ),
                      _c("span", [_vm._v(_vm._s(scope.row.fullName))]),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              width: "90",
              label: "Biệt danh",
              prop: "nickName",
              align: "center",
            },
          }),
          _c("el-table-column", {
            attrs: { align: "center", width: "70", label: "Hiển thị" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("el-checkbox", {
                      attrs: {
                        disabled:
                          scope.row.status === null ||
                          scope.row.status === "Ẩn hóa đơn",
                      },
                      on: {
                        change: function ($event) {
                          return _vm.handelShowOrHidden(scope.row)
                        },
                      },
                      model: {
                        value: scope.row.orderHidden,
                        callback: function ($$v) {
                          _vm.$set(scope.row, "orderHidden", $$v)
                        },
                        expression: "scope.row.orderHidden",
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "Thông tin bổ sung", align: "center", width: "90" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: { size: "mini" },
                        on: {
                          click: function ($event) {
                            return _vm.handleOpenKidDetail(
                              scope.row,
                              scope.row.status
                            )
                          },
                        },
                      },
                      [_c("i", { staticClass: "el-icon-document" })]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { align: "center", width: "75", label: "Tháng tồn" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.count !== 0
                      ? _c(
                          "el-button",
                          {
                            staticClass: "click-in-row",
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.inventoryOrder(scope.row)
                              },
                            },
                          },
                          [_vm._v(_vm._s(scope.row.count) + "\n        ")]
                        )
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { align: "center", width: "110", label: "Trạng thái" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c("div", { class: _vm.getStatusColor(row.status) }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.getStatusValue(row.status)) +
                          "\n        "
                      ),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              width: "110",
              label: "Chuyển thanh toán",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.transactionEntry === "MONEY_WALLET" &&
                    scope.row.afterMoney !== 0
                      ? _c("span", { staticStyle: { color: "orange" } }, [
                          _vm._v("Không chuyển"),
                        ])
                      : _vm._e(),
                    scope.row.transactionEntry === "MONEY_MONTH" &&
                    scope.row.afterMoney !== 0
                      ? _c("span", { staticStyle: { color: "blue" } }, [
                          _vm._v("Sang tháng sau"),
                        ])
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              align: "right",
              width: "120",
              label: "Thiếu/Thừa tháng trước",
              prop: "beforeMoney",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm._f("formatCurrency")(row.beforeMoney)) +
                        "\n      "
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              align: "right",
              width: "120",
              label: "Phải thu tháng này",
              prop: "sumMoney",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm._f("formatCurrency")(row.sumMoney)) +
                        "\n      "
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              align: "right",
              width: "120",
              label: "Đã thu",
              prop: "collectedMoney",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm.getStatusValue(scope.row.status) !== "Chưa có hóa đơn"
                      ? _c(
                          "el-button",
                          {
                            staticClass: "click-in-row",
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.collectedMoneyMethod(
                                  scope.row,
                                  scope.row.status
                                )
                              },
                            },
                          },
                          [
                            scope.row.collectedMoney
                              ? _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("formatCurrency")(
                                        scope.row.collectedMoney
                                      )
                                    )
                                  ),
                                ])
                              : _c("span", [_c("b", [_vm._v("-")])]),
                          ]
                        )
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              align: "right",
              width: "120",
              label: "Tiền mặt",
              prop: "cashMoney",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm._f("formatCurrency")(row.cashMoney)) +
                        "\n      "
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              align: "right",
              width: "120",
              label: "Chuyển khoản",
              prop: "transferMoney",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm._f("formatCurrency")(row.transferMoney)) +
                        "\n      "
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              align: "right",
              width: "120",
              label: "Thiếu / Thừa còn lại",
              prop: "afterMoney",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm._f("formatCurrency")(row.afterMoney)) +
                        "\n      "
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm._l(_vm.dynamicRevenueColumns, function (column) {
            return _c("el-table-column", {
              key: column.prop,
              attrs: {
                align: "right",
                width: "115",
                label: column.label,
                prop: column.prop,
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "header",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tooltip",
                          {
                            attrs: {
                              content: scope.column.label,
                              placement: "top",
                            },
                          },
                          [
                            _c(
                              "span",
                              {
                                staticStyle: { cursor: "pointer" },
                                on: {
                                  click: function ($event) {
                                    return _vm.changeNameRevenus(column.label)
                                  },
                                },
                              },
                              [_vm._v(_vm._s(column.label))]
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm.getStatusValue(scope.row.status) !==
                        "Chưa có hóa đơn"
                          ? _c(
                              "el-button",
                              {
                                staticClass: "click-in-row",
                                attrs: { type: "text" },
                                on: {
                                  click: function ($event) {
                                    return _vm.getDetailKT(
                                      scope.row,
                                      scope.column.label,
                                      scope.row.status
                                    )
                                  },
                                },
                              },
                              [
                                scope.row[column.valueProp]
                                  ? _c("span", [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm._f("formatCurrency")(
                                              scope.row[column.valueProp]
                                            )
                                          )
                                      ),
                                    ])
                                  : _c("span", [_vm._v("-")]),
                              ]
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                ],
                null,
                true
              ),
            })
          }),
          _c("el-table-column", {
            attrs: {
              label: "Tác vụ",
              fixed: "right",
              align: "center",
              width: _vm.responseFilterList.length <= 10 ? "215px" : "198px",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "div",
                      { staticStyle: { display: "inline-flex" } },
                      [
                        _c("el-button", { staticStyle: { display: "none" } }),
                        _vm.checkPermission(["fees_2_excel_cash_payment"])
                          ? _c(
                              "el-button",
                              {
                                attrs: {
                                  size: "mini",
                                  type: _vm.getButtonCashierType(scope.row),
                                  disabled:
                                    scope.row.status === null ||
                                    scope.row.status === "Ẩn hóa đơn" ||
                                    scope.row.sumMoney === 0 ||
                                    scope.row.onlinePaymentSuccessful === true,
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.orderKidsCashierMethod(scope.row)
                                  },
                                },
                              },
                              [_vm._v("Thanh toán\n          ")]
                            )
                          : _vm._e(),
                        _c(
                          "el-button",
                          {
                            attrs: {
                              type: "success",
                              size: "mini",
                              disabled:
                                scope.row.status === null ||
                                scope.row.sumMoney === 0,
                            },
                            on: {
                              click: function ($event) {
                                return _vm.orderKidsHistoryMethod(scope.row)
                              },
                            },
                          },
                          [_vm._v("\n            Lịch sử\n          ")]
                        ),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        2
      ),
      _c("ExcelKidForGroupDetailDialog", {
        ref: "ExcelKidDetail",
        attrs: {
          isOpenKidDetail: _vm.isOpenKidDetailDialog,
          "kids-detail-data": _vm.kidDetailData,
        },
        on: { closeDetailKid: _vm.handleCloseDetailKid },
      }),
      _c("HistoryOderKidsDialogGroup", {
        ref: "OrderKidsHistoryDialog",
        attrs: { isOpenHistoryDialogGroup: _vm.showHistoryDialog },
        on: {
          closeHistoryOrderKids: function ($event) {
            return _vm.closeOrderKidsHistoryDialog()
          },
        },
      }),
      _c("InventoryOrderForGroupDialog", {
        ref: "InventoryOrderDialog",
        attrs: { isOpenInventoryOrder: _vm.showInventoryOrder },
        on: {
          closeInventoryOrder: function ($event) {
            return _vm.closeInventoryOrderDialog()
          },
        },
      }),
      _c("OrderKidsExcelCashierGroup", {
        ref: "OrderKidsExcelCashierGroup",
        attrs: {
          isOpenCashierDialog: _vm.showOrderKidsExcelCashierDialog,
          isActivatedAccount: _vm.isActivatedAccount,
        },
        on: { "dialog-close": _vm.closeOrderKidsExcelCashierDialog },
      }),
      _c("CollectedMoneyForGroupDialog", {
        ref: "CollectedMoneyDialogForGroup",
        attrs: { isOpenCollectedMoney: _vm.showCollectedMoney },
        on: {
          closeCollectedMoney: function ($event) {
            return _vm.closeCollectedMoneyDialog()
          },
        },
      }),
      _c("DetailKTForGroupDialog", {
        ref: "DetailKTForGroupDialog",
        attrs: { isOpenDetailKT: _vm.detailKT },
        on: {
          closeDetailKT: function ($event) {
            return _vm.closeDetailKTDialog()
          },
        },
      }),
      _c("ChangeNameRevenusForGroupDialog", {
        attrs: {
          isOpenChangeNameRevenusDialog: _vm.modifierLesRevenus,
          nameRevenus: _vm.nameRevenus,
          checkDelete: _vm.checkDelete,
        },
        on: { closeChangeNameRevenusDialog: _vm.closeChangeNameRevenusDialog },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }